module.exports = fox._r("images/aboutPhotoEmpty.png", __webpack_public_path__ + "images/aboutPhotoEmpty.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-file-loader!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/file-loader?name=[path][name].[ext]!./images/aboutPhotoEmpty.png
// module id = 475
// module chunks = 4